/**
 * Stable CSS class names for E2E — Schedule list grid.
 */
export const SL = {
    root: 'schedule-list',
    gridWrap: 'schedule-list__grid-wrap',

    cellTooltip: 'schedule-list__cell-tooltip',
    cellTooltipText: 'schedule-list__cell-tooltip-text',

    cellJobIdTooltip: 'schedule-list__cell-job-id-tooltip',
    cellJobIdText: 'schedule-list__cell-job-id-text',

    statusIconSuccess: 'schedule-list__status-icon--success',
    statusIconError: 'schedule-list__status-icon--error',

    rowMenuButton: 'schedule-list-input--button-row-menu',
    rowMenuIcon: 'schedule-list__row-menu-icon',
    rowMenuPaper: 'schedule-list__row-menu-paper',
    rowMenuItemDetail: 'schedule-list-input--menu-item-detail',
    rowMenuItemEdit: 'schedule-list-input--menu-item-edit',
    rowMenuItemDelete: 'schedule-list-input--menu-item-delete',
} as const;

export const slCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

